//DESARROLLO
/*
const URL_BASE = 'http://localhost:80/webPedraza2018/back/servicios';
const RUTA_ITINERARIO = 'http://localhost:80/webPedraza2018/front/public/assets/itinerario/';
*/
//const RUTA_IMAGEN = 'http://localhost:80/webPedraza2018/front/public/assets/img/';


//PRODUCCION
//const URL_BASE = 'http://localhost:80/pedraza/webPedraza2018NewRepo/webPedraza2024/back/servicios';
const URL_BASE = 'https://pedraza.com.ar/back/servicios';
const RUTA_ITINERARIO = 'https://pedraza.com.ar/assets/itinerario/';
const RUTA_IMAGEN = 'https://pedraza.com.ar/assets/img/';
//const RUTA_IMAGEN = 'http://localhost:3000/pedraza/webPedraza2018/front/public/assets/img/';
const RUTA_FACTURAS = 'https://pedraza.com.ar/facturaElectronicaPvyt/php/dao/facturarPdf.php?';


//RUTA DESDE FER
/*
const URL_BASE = 'http://localhost:80/pedraza/webPedraza2018/back/servicios';
const RUTA_ITINERARIO = 'http://localhost:80/pedraza/webPedraza2018/front/public/assets/itinerario/';
const RUTA_IMAGEN = 'http://localhost:3000/pedraza/webPedraza2018/front/public/assets/img/';
const RUTA_FACTURAS = 'https://pedraza.com.ar/facturaElectronicaPvyt/php/dao/facturarPdf.php?';
*/

//RUTA DESDE LEO
/*
const URL_BASE = 'http://localhost:81/webPedraza2018-2020/back/servicios';
const RUTA_ITINERARIO = 'http://localhost:81/webPedraza2018-2020/front/public/assets/itinerario/';
const RUTA_IMAGEN = 'http://localhost:81/webPedraza2018-2020/front/public/assets/img/';
*/

export { URL_BASE, RUTA_ITINERARIO, RUTA_IMAGEN, RUTA_FACTURAS};



// WEBPACK FOOTER //
// ./src/utils/rutasFijas.js